import { MAX_CONTENT_WIDTH } from '@/hooks/useSpaceAfterContent/constants'

const adPadding = 24
const limitedSkySize = 160
const fullSkySize = 300

// Ad loading process:
// limitedRightSky -> lmitedLeftSky -> FullRightSky -> FullLeftSky

export const skyBreakPoints = {
    leftSky: {
        limitedSky: MAX_CONTENT_WIDTH + 2 * limitedSkySize + 2 * adPadding, // 1481px, left sky requires the existence of a full right sky
        fullSky: MAX_CONTENT_WIDTH + 2 * fullSkySize + 2 * adPadding, // 1761px This case has full sky on the left and right side
    },
    rightSky: {
        limitedSky: MAX_CONTENT_WIDTH + limitedSkySize + adPadding, // 1297px, This is the first ad, so there is no left sky yet
        fullSky: MAX_CONTENT_WIDTH + (limitedSkySize + fullSkySize) + 2 * adPadding, // 1621px, The right sky has a higher priority, so it is created right after the left limitedSky
    },
}

// sky ads without 300px ads
export const blockedFormats = [
    'advancedfireplace',
    'advancedfireplace_adnami',
    'breakoutad',
    'doubledynamicsitebar',
    'doublehalfpagead',
    'fireplace',
    'halfpagead',
    'scrollad',
    'shoppableAd',
    'sitebar',
    'skyscraper_200',
    'wallpaper',
]
